import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmCloseDialogComponent } from 'src/app/modules/shared/dialogs/confirm-close-dialog';

@Component({
    selector: 'add-simulation-type-form-app',
    templateUrl: 'add-simulation-type-form.component.html',
    styleUrls: ['./add-simulation-type-form.component.scss'],
})
export class AddSimulationTypeFormComponent {
    simulateTypeForm = new FormGroup({
        name: new FormControl('', { updateOn: 'blur', validators: [Validators.required] }),
        description: new FormControl('', { updateOn: 'blur', validators: [Validators.required] }),
    });

    get nameCtrl() {
        return this.simulateTypeForm.get('name') as FormControl;
    }

    get descriptionCtrl() {
        return this.simulateTypeForm.get('description') as FormControl;
    }

    constructor(
        // @Inject(MAT_DIALOG_DATA) private data: any,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<AddSimulationTypeFormComponent>,
    ) // private simulationTypeService: SimulationTypeService,
    {}

    clickAddSimulationType() {
        if (this.simulateTypeForm.invalid) {
            this.simulateTypeForm.markAllAsTouched();
        } else {
            this.dialogRef.close(this.simulateTypeForm.value);
        }
    }

    onCloseModal() {
        const confirmCloseDialog = this.dialog.open(ConfirmCloseDialogComponent, {
            width: '400px',
            height: '250px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });

        confirmCloseDialog.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.dialogRef.close();
            }
        });
    }
}
